import {
  Menu, MenuButton, MenuList, MenuItem, Avatar, MenuDivider, Tooltip, Button, HStack, Text,
} from "@chakra-ui/react";
import { SHARED_ROUTES } from "definitions/constants/routeConstants";
import { Link } from "react-router";
import useLogout from "hooks/useLogout";
import useCaminoStore from "hooks/useCaminoStore";
import { ProfileIcon } from "./Icon/ProfileIcon";

export default function AvatarDropdown({ isExpanded }: { isExpanded: boolean }) {
  const user = useCaminoStore((state) => state.currentUser);
  const logout = useLogout();

  if (!user) {
    console.log(`ERROR: AVATAR DROPDOWN WAS UNABLE TO FIND USER`);
    return null;
  }

  return (
    <Menu placement="right-start">
      <Tooltip label="Account" isDisabled={isExpanded} placement="right">
        <MenuButton
          as={Button}
          width="100%"
          variant="tertiary"
          justifyContent="start"
          size="xs"
          px="2"
        >
          <HStack gap={isExpanded ? "3" : "0"} transition="gap 0.6s ease-in-out">
            <Avatar size="xs" src={user.avatarUrl} icon={<ProfileIcon user={user} w="100%" h="100%" />} />
            <Text
              maxWidth={isExpanded ? "150px" : "0px"}
              color="gray.600"
              overflow="hidden"
              whiteSpace="nowrap"
              opacity={isExpanded ? 1 : 0}
              transition="opacity 0.6s ease-in-out, max-width 0.6s ease-in-out"
            >
              Account
            </Text>
          </HStack>
        </MenuButton>
      </Tooltip>
      <MenuList zIndex="3">
        <MenuItem as={Link} color="fg.subtle" to={SHARED_ROUTES.profile}>
          Profile
        </MenuItem>
        <MenuItem as={Link} color="fg.subtle" to={SHARED_ROUTES.individualSettings}>
          Settings
        </MenuItem>
        <MenuDivider />
        <MenuItem color="fg.subtle" onClick={logout}>Sign Out</MenuItem>
      </MenuList>
    </Menu>
  );
}
